import React, { useEffect, useState } from "react";
import './home.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
 
import img from '../../Assets/disabilityHistoryMonth2025/invite.JPG'

const Home = () => {
  const [showEventPopup, setShowEventPopup] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 2000 })
    Aos.refresh();
  }, [])

  useEffect(() => {
    if (showEventPopup) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }
  }, [showEventPopup]);

  const handleViewDetails = () => {
    setShowEventPopup(true);
  };

  const handleClosePopup = () => {
    setShowEventPopup(false);
  };
  return (
    <section className='home'>
      <div className="secContainer container">
        <div className="homeText">
          <h2 data-aos="fade-up" className="title">
            LegalNable
          </h2>
          <h3 data-aos="fade-up" className="title2">
            <i>Legal-N-Able</i>
          </h3>
          <p data-aos="fade-up" data-aos-duration="2500" className="subTitle">
            Enabling Success in Education and The Workplace
          </p>

          <button
            data-aos="fade-up"
            data-aos-duration="3000"
            className="btn"
            onClick={() =>
              window.open(
                'https://www.paypal.com/donate/?hosted_button_id=9CLBBUWMLVQYE',
                'paypalPopup',
                'width=600,height=700'
              )
            }
          >
            <h3 data-aos="fade-up">Make Donation</h3>
          </button>

          <button
            data-aos="fade-up"
            data-aos-duration="3000"
            className="btn"
            onClick={() =>
              window.open(
                'https://docs.google.com/forms/d/e/1FAIpQLSebvdaxwJtps6hU4PxPSEtbn9q0SR70Ujip8EZexNj1DTkTSQ/viewform?usp=header',
                'paypalPopup',
                'width=600,height=700'
              )
            }
          >
            <h3 data-aos="fade-up">Become Member</h3>
          </button>
        </div>

        <div className="homeCard grid">
          <>
            <div data-aos="fade-right" data-aos-duration="1000" className="priceDiv">
              {/* <label htmlFor="price">No Upcoming Event</label> */}
              <h4>Disability History Month 2025</h4>
              <button className="btn" onClick={handleViewDetails} >
                View Details
              </button>
            </div>
            {showEventPopup && (
              <div className="popupOverlay">
                <div className="popupCard" data-aos="fade-right" data-aos-duration="1000">
                  <button className="closeBtn" onClick={handleClosePopup}>×</button>
                  <img
                    src={img}
                    alt="Event"
                    className="popupImage"
                  />
                  <div className="popupText">
                    <h1>Disability History Month 2025</h1>
                    <p>
                      🎉 Join us to celebrate Disability History Month 2025! Enjoy a day filled
                      with fun activities, inspiring stories, and delicious food.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        </div>
      </div>
    </section>
  )
}

export default Home